import React, { FC, useContext, useEffect, useState } from 'react';
import { MediaUploaderDropPlace } from '../_DropPlace/MediaUploaderDropPlace';
import { Box } from '@src/atoms/Box';
import { ErrorBlock } from '../_ErrorBlock/ErrorBlock';
import { MediaUploaderFileList } from './_FileList/MediaUploaderFileList';
import { DropzoneState } from 'react-dropzone';
import { MediaUploaderContext } from '../context';

import { MEDIA_UPLOADER_ERRORS_CONTAINER } from '../const';
import { IMediaUploaderFile } from '../MediaUploaderController';

interface IMultiContainerProps {
  dropzone: DropzoneState;
  isDropPlaceGrey: boolean | undefined;
  value: IMediaUploaderFile[];
  onZoom: (i: number) => void;
  isScroll: boolean;
  maxFiles: number;
  maxFileSizeMB: number;
  acceptedFiles: string;
  showErrors?: boolean;
  isDropPlace?: boolean;
  openOuterDropPlace: boolean;
}

export const MultiContainer: FC<IMultiContainerProps> = ({
  dropzone,
  isDropPlaceGrey,
  value,
  isScroll,
  acceptedFiles,
  maxFileSizeMB,
  maxFiles,
  showErrors,
  isDropPlace,
  onZoom,
  openOuterDropPlace,
}) => {
  const { controller, id } = useContext(MediaUploaderContext);

  /**
   * Эта мапа не такая как в контроллере, т.к. так удобней парсить ошибки
   * здесь ключ - ошибка, значение - массив файлов */
  const [errorsMap, setErrorsMap] = useState(controller.errorsMap);

  useEffect(() => {
    controller.addErrorListener({
      listenerName: `_innerMultiContainerListener_${id}`,
      cb: setErrorsMap,
    });
  }, [controller, id]);

  const hasErrors = !!errorsMap.size && showErrors;
  // двойной MediaUploaderDropPlace это фикс клика после dragAndDrop в рамках https://centrateam.atlassian.net/browse/CA-3266
  return (
    <>
      {isDropPlace && openOuterDropPlace && (
        <MediaUploaderDropPlace dropzone={dropzone} isDropPlaceGrey={isDropPlaceGrey} />
      )}
      {isDropPlace && !openOuterDropPlace && (
        <MediaUploaderDropPlace dropzone={dropzone} isDropPlaceGrey={isDropPlaceGrey} />
      )}

      {hasErrors && (
        <Box column fullWidth data-elem={MEDIA_UPLOADER_ERRORS_CONTAINER} gap={8}>
          {Array.from(errorsMap).map(([errorCode, fileList]) => (
            <ErrorBlock
              key={errorCode}
              acceptedFiles={acceptedFiles}
              maxFileSizeMB={maxFileSizeMB}
              maxFiles={maxFiles}
              errorCode={errorCode}
              fileList={fileList}
            />
          ))}
        </Box>
      )}

      <MediaUploaderFileList files={value} onZoom={onZoom} isScroll={isScroll} />
    </>
  );
};
